import 'promise-polyfill/src/polyfill';

Object.assign = require('object-assign');
